import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import Sidebar from '../layouts/Sidebar'
import Tabs from '../components/ui/Tabs'

const TABS = [
    { value: 'teams', label: 'Teams' },
    { value: 'members', label: 'Members' },
]

function Teams() {
    const navigate = useNavigate();
    const location = useLocation();

    const active = location.pathname.endsWith('/members') ? 'members' : 'teams';

    const handleChange = (value) => {
        navigate(value === 'members' ? 'members' : '');
    };

    return (
        <Sidebar title="CBRNE EMS Teams" header={<Tabs tabs={TABS} active={active} onChange={handleChange} />}>
            <Outlet />
        </Sidebar>
    )
}

export default Teams
